
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/chaitanyaa-numero",
      function () {
        return require("private-next-pages/[id]/chaitanyaa-numero.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/chaitanyaa-numero"])
      });
    }
  